import React from 'react';

const IconlyCurvedBold3User = ({ width = 22, height = 20, fill = "#D9D9D9" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 22 20">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M16.396 10.257a6.56 6.56 0 0 0-2.591.517c2.625.758 4.483 2.575 4.533 4.7 1.367-.175 2.842-.692 2.842-2.1 0-1.692-2.192-3.117-4.784-3.117Zm-.025-1.2h.017a3.231 3.231 0 0 0 3.225-3.216 3.233 3.233 0 0 0-3.225-3.225c-.35 0-.683.058-1 .158a5.3 5.3 0 0 1 .908 2.983 5.184 5.184 0 0 1-1 3.109c.342.125.7.191 1.075.191Zm-8.183 1.709a6.703 6.703 0 0 0-2.583-.509c-2.592 0-4.784 1.425-4.784 3.117 0 1.408 1.467 1.917 2.834 2.1.041-2.125 1.9-3.942 4.533-4.708ZM5.605 9.057h.025c.375 0 .733-.066 1.075-.191a5.25 5.25 0 0 1-1.009-3.109 5.3 5.3 0 0 1 .909-2.983c-.317-.1-.65-.158-1-.158A3.226 3.226 0 0 0 2.388 5.84a3.224 3.224 0 0 0 3.217 3.216Z"
      clipRule="evenodd"
    />
    <path
      fill={fill}
      fillRule="evenodd"
      d="M10.996 11.622c-3.3 0-6.09 1.796-6.09 3.923 0 2.75 4.583 2.75 6.09 2.75 2.615 0 6.092-.283 6.092-2.733 0-2.136-2.79-3.94-6.092-3.94Zm.001-1.81h.027a4.01 4.01 0 0 0 2.853-1.193A4.01 4.01 0 0 0 15.05 5.76a4.058 4.058 0 0 0-4.053-4.054A4.057 4.057 0 0 0 6.944 5.76a4.057 4.057 0 0 0 4.053 4.052Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconlyCurvedBold3User;